var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:( _obj = {}, _obj[("footer-" + _vm.type)] = _vm.type, _obj ),attrs:{"data-background-color":_vm.backgroundColor}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav',[_c('ul',[_c('li'),_c('li'),_c('li'),_c('li')])])])}]

export { render, staticRenderFns }